import { Typography } from "@mui/material";
import Breadcrumb from '../../components/Breadcrumbs/Breadcrumbs';
import InventoryForm from "../../components/Inventory/InventoryForm";
import InventoryFormNew from "../../components/Inventory/InventoryFormNew";

const Inventory =() => {
  return(
    <>
     {/* <Breadcrumb /> */}
      <Typography>
         <InventoryFormNew />
      </Typography>
    </>
  );
};
export default Inventory;